// extracted by mini-css-extract-plugin
module.exports = {"item":"src-containers-Form-SimplifiedBuilder-Internal-PaletteItem___item"};